export default __webpack_public_path__ + "static/infra_2-a810cea473e59b2203f3aef8fcc2b976.jpeg";